import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { isFalsy, isTruthy } from 'lib/Helpers';
import { TrendArrow, TrendEmpty } from 'components/CommonIcons';

import { determineTrendClass } from './utils';
import * as styles from './Trend.scss';

const findColor = float => {
  return Math.sign(float) === 1
    ? '#69BC8A'
    : '#AE314A';
};

/**
 * Reusable Trend Component
 * @function Trend
 * @param {Object}
 * @return {ReactElement}
 */
const Trend = ({ className, float, formatterFn = (val) => val, style, trendText, onlyText = false }) => {
  const isFloatEmptyOrZero = isFalsy(float);
  const TrendSvg = isTruthy(isFloatEmptyOrZero)
    ? TrendEmpty
    : TrendArrow;
  const value = isFalsy(isFloatEmptyOrZero) ? formatterFn(float) : '0.00%';

  return (
    <div className={classNames(styles.trend, className)} style={style}>
      {!onlyText ?
        <>
          <TrendSvg color={findColor(float)} className={determineTrendClass({ float, key: 'svg' })} />
          <p className={classNames(styles.value, determineTrendClass({ float, key: 'value' }))} title={value}>
            {value}
          </p>
        </>
        : null}
      {isTruthy(trendText) &&
        <p
          className={classNames(styles.trendText, determineTrendClass({ float, key: 'value' }))}
          title={trendText}
        >
          {trendText}
        </p>}
    </div>
  );
};

Trend.propTypes = {
  onlyText: PropTypes.bool,
  className: PropTypes.string,
  float: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  formatterFn: PropTypes.func,
  style: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
  ),
  trendText: PropTypes.string,
};

export default Trend;
